// Leads Source Management Permissions

export const LEADS_SOURCE_INDEX = 214;
export const LEADS_FAVOURITES_INDEX = 140;
export const LEADS_SOURCE_CREATE = 215;
export const LEADS_SOURCE_UPDATE = 216;
export const LEADS_SOURCE_DELETE = 217;
export const LEADS_SOURCES_RESTORE = 1400;
